import {
  getDynamicEndpointURL,
  getFullRequestEndpointURL,
} from '../common/utils/data-utils';

import fetchAPI from './fetch-helper';

export const START_TRACKING_INTERVAL = 'START_TRACKING_INTERVAL';
export const STOP_TRACKING_INTERVAL = 'STOP_TRACKING_INTERVAL';

export const LOADING_INIT_DATA = 'LOADING_INIT_DATA';
export const LOAD_INIT_DATA_FAILURE = 'LOAD_INIT_DATA_FAILURE';
export const LOAD_INIT_DATA_SUCCESS = 'LOAD_INIT_DATA_SUCCESS';

export const LOADING_FULL_DATA = 'LOADING_FULL_DATA';
export const LOAD_DATA_FULL_ERROR = 'LOAD_DATA_FULL_ERROR';
export const LOAD_DATA_FULL_SUCCESS = 'LOAD_DATA_FULL_SUCCESS';

export const LOADING_DYNAMIC_DATA = 'LOADING_DYNAMIC_DATA';
export const LOAD_DATA_DYNAMIC_ERROR = 'LOAD_DATA_DYNAMIC_ERROR';
export const LOAD_DATA_DYNAMIC_SUCCESS = 'LOAD_DATA_DYNAMIC_SUCCESS';

export const UPDATE_STATUS_EVENTS = 'UPDATE_STATUS_EVENTS';
export const UPDATE_STATUS_MESSAGE = 'UPDATE_STATUS_MESSAGE';

export const THROTTLE_REQUESTS = 'THROTTLE_REQUESTS';
export const RETRY_LOADING_DYNAMIC_DATA = 'RETRY_LOADING_DYNAMIC_DATA';

export const startTrackingInterval = data => ({
  type: START_TRACKING_INTERVAL,
  data,
});

export const stopTrackingInterval = data => ({
  type: STOP_TRACKING_INTERVAL,
  data,
});

/* Happy cases */
export const loadingInitData = data => ({
  type: LOADING_INIT_DATA,
  data,
});

export const loadInitDataSuccess = data => ({
  type: LOAD_INIT_DATA_SUCCESS,
  data,
});

export const loadingFullData = data => ({
  type: LOADING_FULL_DATA,
  data,
});

export const loadDataFullSuccess = data => ({
  type: LOAD_DATA_FULL_SUCCESS,
  data,
});

export const loadingDynamicData = data => ({
  type: LOADING_DYNAMIC_DATA,
  data,
});

export const loadDataDynamicSuccess = data => ({
  type: LOAD_DATA_DYNAMIC_SUCCESS,
  data,
});

/* Error cases */
export const loadDataFullError = val => ({
  type: LOAD_DATA_FULL_ERROR,
  val,
});

export const loadDataDynamicError = val => ({
  type: LOAD_DATA_DYNAMIC_ERROR,
  val,
});

export const loadInitDataError = val => ({
  type: LOAD_INIT_DATA_FAILURE,
  val,
});

export const throttleRequests = val => ({
  type: THROTTLE_REQUESTS,
  val,
});

export const retryLoadingDynamicData = () => ({
  type: RETRY_LOADING_DYNAMIC_DATA,
});

export const fetchInitState = (guid, params, headers) => {
  const endpoint = getFullRequestEndpointURL(guid, params);
  return fetchAPI(
    endpoint,
    loadingInitData,
    loadInitDataSuccess,
    loadInitDataError,
    null,
    headers,
  );
};

export const fetchFullData = (guid, params, headers) => {
  const endpoint = getFullRequestEndpointURL(guid, params);
  return fetchAPI(
    endpoint,
    loadingFullData,
    loadDataFullSuccess,
    loadDataFullError,
    null,
    headers,
  );
};

export const fetchDynamicData = (guid, params, headers) => {
  const endpoint = getDynamicEndpointURL(guid, params);
  return fetchAPI(
    endpoint,
    loadingDynamicData,
    loadDataDynamicSuccess,
    loadDataDynamicError,
    retryLoadingDynamicData,
    headers,
  );
};
